import React, { Component } from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Link } from "react-router-dom";

class Home extends Component {
  render() {
    const theme = this.props.theme;
    const businessCards = [
      {
        title: "KRN Tech",
        badge: "Company Profile",
        description:
          "A focused technology brand for leads, clients, and hiring partners. Built to communicate capability, trust, and digital execution with clarity.",
        accent: "#14BF63",
        link: null,
      },
      {
        title: "MCR Consultancy",
        badge: "Career & Training",
        description:
          "A future-focused training and consulting arm that helps people prepare for better technology careers, industry readiness, and stronger long-term growth.",
        accent: "#3B82F6",
        link: null,
      },
      {
        title: "My Portfolio",
        badge: "Digital Presence",
        description:
          "A personal technology portfolio that presents experience, product thinking, technical execution, and credibility in a polished, lead-ready format.",
        accent: "#F59E0B",
        link: "/my-portfolio",
      },
    ];

    return (
      <div>
        <Header theme={theme} />
        <Greeting theme={theme} />

        <div
          style={{
            width: "min(1200px, 90%)",
            margin: "32px auto 0",
            padding: "0 10px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "24px",
            }}
          >
            {businessCards.map((card) => {
              const cardContent = (
                <div
                  style={{
                    background: theme.body,
                    border: `1px solid ${theme.secondaryText}33`,
                    borderRadius: "20px",
                    padding: "28px 24px",
                    boxShadow: `0 10px 30px ${theme.dark}10`,
                    cursor: card.link ? "pointer" : "default",
                    transition: card.link ? "all 0.3s ease" : "none",
                  }}
                  onMouseEnter={(e) => {
                    if (card.link) {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = `0 20px 40px ${theme.dark}20`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (card.link) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = `0 10px 30px ${theme.dark}10`;
                    }
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "6px 10px",
                      borderRadius: "999px",
                      background: `${card.accent}1A`,
                      color: card.accent,
                      fontSize: "12px",
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      marginBottom: "14px",
                    }}
                  >
                    {card.badge}
                  </div>
                  <h3
                    style={{
                      fontSize: "28px",
                      margin: "0 0 10px",
                      color: theme.text,
                      lineHeight: 1.2,
                    }}
                  >
                    {card.title}
                  </h3>
                  <p
                    style={{
                      margin: 0,
                      lineHeight: 1.7,
                      fontSize: "15px",
                      color: theme.secondaryText,
                    }}
                  >
                    {card.description}
                  </p>
                </div>
              );

              if (card.link) {
                return (
                  <Link
                    key={card.title}
                    to={card.link}
                    style={{ textDecoration: "none" }}
                  >
                    {cardContent}
                  </Link>
                );
              }

              return <div key={card.title}>{cardContent}</div>;
            })}
          </div>
        </div>

        <Footer theme={theme} isDark={this.props.isDark} onToggle={this.props.onToggle} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Home;
